import { getFormattedPrice } from "../../utils";
import { getTotalPrice, getTotalQuantity } from "../../services/cartUtils";

const MultipleProductsAddPopupContent = ({ products, showVAT }) => {
  const totalQuantity = getTotalQuantity(products);
  const totalPrice = getTotalPrice(products, showVAT);

  return (
    <div className="multi-products-added-popup">
      <p className="notification-title">Tilføjet til indkøbskurven</p>
      <div className="d-flex align-items-center">
        <div className="image-wrapper">
          <svg className="icon icon--cart-plus" width="100" height="45">
            <use
              xlinkHref={`${$(
                "#STATIC_ASSETS_URL"
              ).val()}/images/sprites/symbol/sprite.svg#cart-plus`}
            />
          </svg>
        </div>
        <div className="content-wrapper">
          <div>{products.length} produkter</div>
          <div>{totalQuantity} stk</div>
          <div>Total: {getFormattedPrice(totalPrice)}</div>
        </div>
      </div>
    </div>
  );
};

export default MultipleProductsAddPopupContent;
